export default __webpack_public_path__ + "8f51717.png";